import React from 'react';

const PaginationControls = ({ currentPage, totalPages, onPageChange, rowsPerPage, onRowsPerPageChange }) => {
    const maxVisiblePages = 3;
    let pages = [];

    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    if (adjustedStartPage > 1) {
        pages.push(1);
        if (adjustedStartPage > 2) {
            pages.push('...');
        }
    }

    for (let i = adjustedStartPage; i <= endPage; i++) {
        pages.push(i);
    }

    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            pages.push('...');
        }
        pages.push(totalPages);
    }

    return (
        <div className="flex justify-between items-center bg-white px-2 py-1 shadow-sm border-t border-gray-200 text-sm w-full">
            {/* Left-aligned pagination controls */}
            <div className="flex space-x-1">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-2 py-1 border border-gray-300 rounded bg-white hover:bg-gray-100 disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                    ←
                </button>
                <div className="flex border border-gray-300 rounded overflow-hidden">
                    {pages.map((page, index) =>
                        page === '...' ? (
                            <span key={index} className="px-2 py-1 border border-gray-300 bg-white">
                                ...
                            </span>
                        ) : (
                            <button
                                key={index}
                                onClick={() => onPageChange(page)}
                                className={`px-2 py-1 border-x text-sm ${
                                    page === currentPage
                                        ? 'border-blue-500 bg-blue-500 text-white font-medium'
                                        : 'border-gray-300 bg-white hover:bg-gray-100'
                                }`}
                            >
                                {page}
                            </button>
                        )
                    )}
                </div>
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-2 py-1 border border-gray-300 rounded bg-white hover:bg-gray-100 disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                    →
                </button>
            </div>

            {/* Right-aligned rows per page dropdown */}
            <div className="flex items-center space-x-1">
                <span className="text-gray-600">Rows:</span>
                <select
                    value={rowsPerPage}
                    onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
                    className="px-1 py-0.5 border border-gray-300 rounded bg-white text-sm"
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>
        </div>
    );
};

export default PaginationControls;